import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import "vfonts/Lato.css";
import "vfonts/FiraCode.css";
import "./assets/styles.scss";
import apiPlugin from "./plugins/apiPlugin";

const app = createApp(App);
app.use(apiPlugin).use(router);
app.mount("#app");
